import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const products = () => {
  const auth = useAuth();

  async function list() {
    let retorno;
    try {
        const {data} = await http.get('/products', auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function restock(id, payload) {
    try {
      await http.post('/products/'+id+'/restock', payload, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function discard(id, payload) {
    try {
      await http.post('/products/'+id+'/discard', payload, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  return {list, restock, discard}
}